import { useEffect, useRef, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator, ColumnComponent } from "tabulator-tables";
import { IAtivosModel, IMovimentacaoModel } from "../modules/services/core/_models";
import Select from "react-select";
import { MapContainer, TileLayer, LayersControl } from 'react-leaflet';
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import { useAuth } from "../modules/auth/core/Auth";
import moment from "moment";
// Importe o FiltroGlobal e o hook para consumir os dados do filtro
import { FiltroGlobal, useFiltrosAtivos } from "../../components/FiltrosGlobais";

interface Organization {
  OrganizationId: number;
  OrganizationName: string;
  Idcorporacao: number;
  CorporationName: string;
}

const MovimentacaoTable: React.FC = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const configTableRef = useRef<HTMLDivElement>(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const mainTableRef = useRef<any>(null);
  const configTableRefInstance = useRef<any>(null);

  const [filteredRowCount, setFilteredRowCount] = useState<number>(0);
  interface IMovimentacaoWithHistory extends IMovimentacaoModel {
    IdAtivo?: number;
    movementHistory: { lat: number; lng: number; timestamp: any }[];
  }

  // ADICIONE estas duas linhas
  const iconCacheRef = useRef<Map<number, L.DivIcon | null>>(new Map());
  const [ativoIcons, setAtivoIcons] = useState<Map<number, L.DivIcon>>(new Map());

  const [selectedAtivo, setSelectedAtivo] = useState<IMovimentacaoWithHistory | null>(null);
  const [mapReady, setMapReady] = useState(false);
  const mapRef = useRef<L.Map | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentPositionIndex, setCurrentPositionIndex] = useState(0);
  const [polyline, setPolyline] = useState<L.Polyline | null>(null);
  const [marker, setMarker] = useState<L.Marker | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [lastFrameTime, setLastFrameTime] = useState(Date.now());
  const [availableDates, setAvailableDates] = useState<string[]>([]);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [frameDuration, setFrameDuration] = useState(2); // segundos entre pontos
  const [animationState, setAnimationState] = useState<AnimationState>({
    isPlaying: false,
    currentIndex: 0,
    speed: 1 // padrão: 1 ponto por segundo
  });
  const linePointsRef = useRef<L.LatLng[]>([]);

  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [selectedRows, setSelectedRows] = useState<number>(100);

  // Use o hook do FiltroGlobal para acessar o estado dos filtros
  const {
    selectedCorporation,
    selectedOrganizations,
    availableCorporations
  } = useFiltrosAtivos();

  interface IMovimentacaoPayloadRequest {
    Corporacao?: string;
    DataAte?: string;
    organicoes?: string[];
    Ativos?: string[];
    Gateways?: string[];
  }
  interface MovementPoint {
    lat: number;
    lng: number;
    timestamp: string;
  }

  interface AnimationState {
    isPlaying: boolean;
    currentIndex: number;
    speed: number; // pontos por segundo
  }

  const { auth } = useAuth();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [Mqtt, setMqtt] = useState<IMovimentacaoModel[]>([]);


  // Logica dos icones


  const createDivIconFromSvg = (svgContent: string): L.DivIcon => {
    let sanitizedSvg = (svgContent || '').trim();
    try {
      if (sanitizedSvg.includes('\\')) {
        sanitizedSvg = JSON.parse(`"${sanitizedSvg}"`);
      }
    } catch (e) {
      console.warn('Erro ao decodificar SVG:', e);
    }

    return L.divIcon({
      className: 'custom-svg-icon',
      html: `
      <div style="
        width: 28px; height: 28px; border-radius: 50%; background: #ffffff; border: 2px solid #3388ff;
        display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.4);
        line-height: 0;
      ">
        <div style="
          width: 18px; height: 18px; display:flex; align-items:center; justify-content:center; overflow:hidden;
          line-height: 0; transform: translate(1px, 0.5px);
        ">
          ${sanitizedSvg}
        </div>
      </div>
    `,
      iconSize: [28, 28],
      iconAnchor: [14, 28]
    });
  };

  // Função para criar ícone DIV a partir de classe CSS
  const createDivIconFromClass = (className: string): L.DivIcon => {
    const safeClass = (className || '').trim();
    return L.divIcon({
      className: 'custom-class-icon',
      html: `
      <div style="
        width: 28px; height: 28px; border-radius: 50%; background: #ffffff; border: 2px solid #3388ff;
        display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.4);
        color: #3388ff;
        line-height: 0;
      ">
        <i class="ui icon ${safeClass}" style="
          font-size:16px; width:18px; height:18px; display:flex; align-items:center; justify-content:center;
          line-height: 0; transform: translate(1px, 1px);
        "></i>
      </div>
    `,
      iconSize: [28, 28],
      iconAnchor: [14, 28]
    });
  };

  // Função para buscar ícones em lote
  const fetchIconsForAtivos = async (
    idsAtivos: number[],
    auth?: any,
    backendUrl?: string,
    iconCache?: Map<number, L.DivIcon | null>
  ): Promise<Map<number, L.DivIcon | null>> => {
    const resultMap = new Map<number, L.DivIcon | null>();
    if (!idsAtivos.length || !auth?.Token || !backendUrl) {
      return resultMap;
    }

    const idsParaBuscar = iconCache
      ? idsAtivos.filter(id => !iconCache.has(id))
      : idsAtivos;

    if (!idsParaBuscar.length) {
      return new Map();
    }

    try {
      const idApp = parseInt(process.env.REACT_APP_POWER_BI_APPLICATIONID || '0', 10) || 0;
      const url = `${backendUrl}/api/PrismTags/by-idsprism`;
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.Token}`
        },
        body: JSON.stringify({ IdsPrism: idsParaBuscar, IdApp: idApp }),
      });

      if (!resp.ok) return resultMap;

      const response = await resp.json();
      if (!response?.Data || !Array.isArray(response.Data)) return resultMap;

      for (const item of response.Data) {
        const idAtivo = item.IdPrism;
        let value = item?.Value;
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (e) { continue; }
        }

        const svg: string | undefined = value?.SVG;
        const klass: string | undefined = value?.Class;
        let icon: L.DivIcon | null = null;

        if (svg && svg.trim()) icon = createDivIconFromSvg(svg);
        else if (klass && klass.trim()) icon = createDivIconFromClass(klass);

        if (iconCache) iconCache.set(idAtivo, icon);
        resultMap.set(idAtivo, icon);
      }
      return resultMap;
    } catch (e) {
      console.error('Erro ao buscar ícones:', e);
      return resultMap;
    }
  };

  const updateAtivoIcons = async (movimentacoes: IMovimentacaoModel[]) => {
    const idsUnicos = Array.from(new Set(
      movimentacoes
        .map(m => m.idAtivo)
        .filter((id): id is number => id !== undefined && id !== null)
    ));

    if (idsUnicos.length === 0) return;

    const novosIcones = await fetchIconsForAtivos(idsUnicos, auth, backendUrl, iconCacheRef.current);

    const iconMap = new Map<number, L.DivIcon>();
    // Converte as entradas do Map para um Array antes de usar o forEach
    Array.from(novosIcones.entries()).forEach(([id, icon]) => {
      if (icon) {
        iconMap.set(id, icon);
      }
    });
    if (iconMap.size > 0) {
      setAtivoIcons(prev => {
        const newMap = new Map(prev);
        Array.from(iconMap.entries()).forEach(([id, icon]) => {
          newMap.set(id, icon);
        });

        return newMap;
      });
    }
  };

  //fim da logica dos icones


  async function exportTableToExcel() {
    const tableData = mainTableRef.current.getData();
    try {
      const endpoint = `${backendUrl}/Report/AtivoListExcel`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(tableData)
      });
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Ativos.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Erro ao baixar o arquivo Excel:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao fazer o POST:', error);
    }
  }

  const fetchAvailableDates = async () => {
    const corporationName = selectedCorporation
      ? availableCorporations.find(c => c.id === selectedCorporation)?.name
      : null;

    if (!corporationName || selectedOrganizations.length === 0) {
      setAvailableDates([]);
      return;
    }

    const organizacao = selectedOrganizations[0];

    try {
      const url = `${backendUrl}/api/ConsolidadoMqtt/datas?corporacao=${encodeURIComponent(corporationName)}&organizacao=${encodeURIComponent(organizacao)}`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${auth?.Token}`
        }
      });
      if (!response.ok) {
        throw new Error('Erro ao buscar as datas');
      }
      const datesData = await response.json();
      const sortedDates = datesData.sort((a: string, b: string) => new Date(b).getTime() - new Date(a).getTime());
      setAvailableDates(sortedDates);
    } catch (error) {
      console.error("Erro ao buscar datas disponíveis:", error);
      setAvailableDates([]);
    }
  };

  useEffect(() => {
    fetchAvailableDates();
  }, [selectedCorporation, selectedOrganizations]); // Reaja às mudanças do filtro global

  const fetchMovimentacaoData = async (filters: Partial<IMovimentacaoPayloadRequest> = {}, page = selectedPage, rows = selectedRows) => {
    try {
      // Obtenha o nome da corporação a partir do ID selecionado no filtro global
      const corporationName = selectedCorporation
        ? availableCorporations.find(corp => corp.id === selectedCorporation)?.name
        : undefined;

      const payload = {
        Corporacao: corporationName,
        // Use as organizações do filtro global
        Organizacoes: Array.isArray(selectedOrganizations) && selectedOrganizations.length > 0 ? selectedOrganizations : ["Todos"],
        Data: filters.DataAte || moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      const response = await fetch(`${backendUrl}/api/Movimentacoes/Movimentacoes?rows=${rows}&page=${page}`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json-patch+json',
          'Authorization': `Bearer ${auth?.Token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro HTTP ${response.status}: ${errorText}`);
      }

      const responseData = await response.json();

      if (!Array.isArray(responseData)) {
        throw new Error('Resposta não é um array');
      }

      const mqttData = responseData.map(item => ({
        ...item,
        Latitude: parseFloat(item.Latitude),
        Longitude: parseFloat(item.Longitude)
      }));
      setMqtt(mqttData);
      await updateAtivoIcons(mqttData);
      return mqttData;

    } catch (error) {
      console.error("Erro completo na requisição MQTT:", error);
      setMqtt([]);
      return [];
    }
  };

  // Atualiza os dados quando os filtros globais ou a data selecionada mudam
  useEffect(() => {
    fetchMovimentacaoData({
      DataAte: selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : undefined
    });
  }, [selectedCorporation, selectedOrganizations, selectedDate]); // Reaja às mudanças do filtro global


  const loadConfigTable = () => {
    const cols = mainTableRef.current
      .getColumns()
      .map((col: ColumnComponent, index: number) => ({
        id: index + 1,
        title: col.getDefinition().title || col.getField(),
        field: col.getField(),
        visible: col.isVisible(),
      }));

    if (configTableRef.current) {
      if (configTableRefInstance.current) {
        configTableRefInstance.current.destroy();
      }

      configTableRefInstance.current = new Tabulator(configTableRef.current, {
        data: cols,
        layout: "fitDataFill",
        movableRows: true,
        headerVisible: false,
        columns: [
          {
            title: "Mover",
            formatter: "handle",
            headerSort: false,
            width: 30,
            minWidth: 30,
          },
          {
            title: "Coluna",
            field: "title",
            formatter: (cell) => ` ${cell.getValue()}`,
          },
          {
            title: "Visível",
            field: "visible",
            formatter: "tickCross",
            editor: true,
          },
        ],
      });
      mainTableRef.current.redraw();
    }
  };

  const createOrUpdateMarker = (position: L.LatLngExpression, ativoId?: number) => {
        if (!mapRef.current) return;

        const icon = getMarkerIcon(ativoId);
        if (marker) {
            marker.setLatLng(position);
            marker.setIcon(icon);
        } 
        else {
            const newMarker = L.marker(position, {
                icon: icon,
                zIndexOffset: 1000
            }).addTo(mapRef.current);
            setMarker(newMarker);
        }
    };

  const handleRowClick = (e: Event, row: any) => {
    const data = row.getData();
    const tableData = mainTableRef.current.getData(true);
    const ativoMovements = tableData
      .filter((item: IMovimentacaoModel) => item.Ativo === data.Ativo)
      .sort((a: { timestampIni: string | number | Date; }, b: { timestampEnd: string | number | Date; }) => new Date(a.timestampIni).getTime() - new Date(b.timestampEnd).getTime());
    resetAnimation();
    linePointsRef.current = [];
    setSelectedAtivo({
      ...data,
      movementHistory: ativoMovements.map((item: { Latitude: any; Longitude: any; timestampIni: any; }) => ({
        lat: item.Latitude,
        lng: item.Longitude,
        timestamp: item.timestampIni
      }))
    });
    setAnimationState({
      isPlaying: false,
      currentIndex: 0,
      speed: 1
    });
    const rows = mainTableRef.current.getRows();
    rows.forEach((r: any) => r.getElement().classList.remove('selected'));
    row.getElement().classList.add('selected');
  };

  useEffect(() => {
    if (!selectedAtivo?.movementHistory || !animationState.isPlaying) return;

    const history = selectedAtivo.movementHistory;
    if (animationState.currentIndex >= history.length - 1) {
      setAnimationState(prev => ({ ...prev, isPlaying: false }));
      return;
    }

    const intervalTime = 1000 / animationState.speed;
    const intervalId = setInterval(() => {
      setAnimationState(prev => {
        const nextIndex = prev.currentIndex + 1;
        updateMarkerAndLine(
          history[prev.currentIndex],
          history[nextIndex],
          nextIndex
        );
        return {
          ...prev,
          currentIndex: nextIndex,
          isPlaying: nextIndex < history.length - 1
        };
      });
    }, intervalTime);

    return () => clearInterval(intervalId);
  }, [selectedAtivo, animationState.isPlaying, animationState.speed]);


  const updateMarkerAndLine = (
    currentPoint: MovementPoint,
    nextPoint: MovementPoint,
    currentIndex: number
  ) => {

    if (!mapRef.current || !selectedAtivo) return;
    linePointsRef.current.push(L.latLng(currentPoint.lat, currentPoint.lng));
    const icon = getMarkerIcon(selectedAtivo.IdAtivo);
    createOrUpdateMarker([currentPoint.lat, currentPoint.lng], selectedAtivo.IdAtivo);
    if (!polyline) {
      const newPolyline = L.polyline(linePointsRef.current, {
        color: '#3388ff',
        weight: 5,
        opacity: 0.7,
        lineJoin: 'round',
        smoothFactor: 1
      }).addTo(mapRef.current);
      setPolyline(newPolyline);
    } else {
      polyline.setLatLngs(linePointsRef.current);
      polyline.bringToBack();
    }

    mapRef.current.panTo([currentPoint.lat, currentPoint.lng]);

    if (marker) {
      marker.bindPopup(`
                <div style="min-width: 200px">
                <strong>Ativo:</strong> ${selectedAtivo.Ativo}<br>
                <strong>Posição:</strong> ${currentIndex + 1} de ${selectedAtivo.movementHistory.length}<br>
                <strong>Hora:</strong> ${moment(currentPoint.timestamp, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY HH:mm:ss")}<br>
                <strong>Coordenadas:</strong> ${currentPoint.lat.toFixed(4)}, ${currentPoint.lng.toFixed(4)}
                </div>
            `).openPopup();
    }
  };

  useEffect(() => {
    return () => {
      resetAnimation();
    };
  }, []);

  const changeSpeed = (newSpeed: number) => {
    setAnimationState(prev => ({
      ...prev,
      speed: Math.max(0.1, Math.min(10, newSpeed))
    }));
  };

  const toggleAnimation = () => {
    setAnimationState(prev => ({
      ...prev,
      isPlaying: !prev.isPlaying,
      currentIndex: !prev.isPlaying && prev.currentIndex >= (selectedAtivo?.movementHistory.length || 0) - 1
        ? 0
        : prev.currentIndex
    }));
  };

  const resetAnimation = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (marker && mapRef.current?.hasLayer(marker)) {
      mapRef.current.removeLayer(marker);
    }
    if (polyline && mapRef.current?.hasLayer(polyline)) {
      mapRef.current.removeLayer(polyline);
    }
    setMarker(null);
    setPolyline(null);
    linePointsRef.current = [];
    setIsPlaying(false);
    setCurrentPositionIndex(0);
    if (selectedAtivo?.movementHistory?.length && mapRef.current) {
      const firstPoint = selectedAtivo.movementHistory[0];
      mapRef.current.flyTo([firstPoint.lat, firstPoint.lng], 15);
    }
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (mainTableRef.current) {
      mainTableRef.current.replaceData(Mqtt);
    }
  }, [Mqtt]);

  useEffect(() => {
    const footerContent = Mqtt.length > 0
      ? `<div>${Mqtt.length} Ativos carregados (linhas filtradas: ${filteredRowCount})</div>`
      : `<div>Nenhum dado encontrado no momento.</div>`;

    if (tableRef.current && !mainTableRef.current) {
      mainTableRef.current = new Tabulator(tableRef.current, {
        data: Mqtt,
        height: 650,
        layout: "fitDataFill",
        movableColumns: true,
        resizableColumnFit: true,
        columnHeaderVertAlign: "top",
        footerElement: footerContent,
        columns: [
          {
            title: "Organização",
            field: "Organizacao",
            sorter: "string",
            headerFilter: "list",
            headerFilterParams: {
              values: true,
              multiselect: true,
              clearable: true
            }
          },
          {
            title: "Ativo",
            field: "Ativo",
            headerFilter: "list",
            headerFilterParams: {
              values: true,
              multiselect: true,
              clearable: true
            },
            formatter: (cell) => {
              const data = cell.getRow().getData();
              return `
                                <a href='/detalhes-do-ativo?ativo=${data.Ativo}' target='_blank' style='margin-right: 10px;'>
                                <i class='ui icon external alternate' style='cursor: pointer;'></i>
                                </a>
                                ${cell.getValue()}
                            `;
            },
          },
          {
            title: "Tipo de Ativo",
            field: "AtivoTipo",
            sorter: "string"
          },
          {
            title: "Local",
            field: "Local",
            width: 240,
            headerFilter: "list",
            headerFilterParams: {
              values: true,
              multiselect: true,
              clearable: true
            }
          },
          {
            title: "Tipo de Local",
            field: "LocalTipo",
            sorter: "string"
          },
          {
            title: "Data Início",
            field: "timestampIni",
            sorter: "datetime",
            width: 240,
            sorterParams: {
              format: "DD/MM/YYYY HH:mm:ss"
            },
            formatter: (cell) => {
              const value = cell.getValue();
              if (!value) return "(data inválida)";
              const date = moment(value, "DD/MM/YYYY HH:mm:ss");
              return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "(data inválida)";
            }
          },
          {
            title: "Data Fim",
            field: "timestampEnd",
            width: 240,
            sorter: "datetime",
            sorterParams: {
              format: "DD/MM/YYYY HH:mm:ss"
            },
            formatter: (cell) => {
              const value = cell.getValue();
              if (!value) return "(data inválida)";
              const date = moment(value, "DD/MM/YYYY HH:mm:ss");
              return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "(data inválida)";
            }
          },
          {
            title: "Coordenadas",
            field: "Latitude",
            width: 200,
            formatter: (cell) => {
              const data = cell.getRow().getData();
              if (data.Latitude && data.Longitude) {
                return `${data.Latitude.toFixed(4)}, ${data.Longitude.toFixed(4)}`;
              }
              return "Sem coordenadas";
            },
            hozAlign: "center",
          },
        ],
      });
      mainTableRef.current.on("dataLoaded", loadConfigTable);
      mainTableRef.current.on("rowClick", handleRowClick);
      mainTableRef.current.on("dataFiltered", (filters: any, rows: any[]) => {
        setFilteredRowCount(rows.length);
        const footerEl = mainTableRef.current.element.querySelector(".tabulator-footer");
        if (footerEl) {
          footerEl.innerHTML = Mqtt.length > 0
            ? `<div>${Mqtt.length} Ativos carregados (linhas filtradas: ${rows.length})</div>`
            : `<div>Nenhum dado encontrado no momento.</div>`;
        }
      });
    } else if (mainTableRef.current) {
      mainTableRef.current.replaceData(Mqtt);
      const footerEl = mainTableRef.current.element.querySelector(".tabulator-footer");
      if (footerEl) {
        footerEl.innerHTML = Mqtt.length > 0
          ? `<div>${Mqtt.length} Ativos carregados (linhas filtradas: ${filteredRowCount})</div>`
          : `<div>Nenhum dado encontrado no momento.</div>`;
      }
    }
  }, [Mqtt, filteredRowCount]);

  const defaultMarkerIcon = L.icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34]
  });

  const getMarkerIcon = (ativoId?: number): L.Icon | L.DivIcon => {
    if (ativoId && ativoIcons.has(ativoId)) {
      return ativoIcons.get(ativoId)!;
    }
    return defaultMarkerIcon;
  };

  const handleSettingsClick = () => {
    setSidebarVisible(!sidebarVisible);
    if (!sidebarVisible) {
      setTimeout(loadConfigTable, 300);
    }
  };

  const handleDateChange = (selectedOption: any) => {
    setSelectedDate(selectedOption ? selectedOption.value : null);
  };

  const applyConfigChanges = () => {
    const updatedCols = configTableRefInstance.current.getData();
    const newColumns = updatedCols.map((col: any) => {
      const originalCol = mainTableRef.current.getColumn(col.field);
      if (originalCol) {
        const definition = originalCol.getDefinition();
        return {
          ...definition,
          visible: col.visible,
        };
      }
      return col;
    });
    mainTableRef.current.setColumns(newColumns);
  };

  const handleDownloadCsv = () => {
    mainTableRef.current.download("csv", "ativos.csv");
  };

  const limparFiltros = () => {
    if (mainTableRef.current) {
      mainTableRef.current.clearHeaderFilter();
      mainTableRef.current.replaceData(Mqtt);
      mainTableRef.current.redraw(true);
    }
  };

  useEffect(() => {
    if (mapReady && selectedAtivo && mapRef.current) {
      resetAnimation();
      linePointsRef.current = [];
      if (selectedAtivo.movementHistory?.length > 0) {
        const firstPoint = selectedAtivo.movementHistory[0];
        linePointsRef.current = [L.latLng(firstPoint.lat, firstPoint.lng)];
        const newPolyline = L.polyline(linePointsRef.current, {
          color: '#3388ff',
          weight: 5,
          opacity: 0.7,
          lineJoin: 'round'
        }).addTo(mapRef.current);
        setPolyline(newPolyline);
        createOrUpdateMarker([firstPoint.lat, firstPoint.lng], selectedAtivo.IdAtivo);
        
        mapRef.current.flyTo([firstPoint.lat, firstPoint.lng], 15);
      }
    }
  }, [selectedAtivo, mapReady, ativoIcons]);

  return (
    <div className="d-flex" style={{ position: "relative" }}>
      <div style={{ width: sidebarVisible ? "80%" : "100%", transition: "0.3s" }}>
        <h1 className="ui header">Movimentação de ativos</h1>
        <div style={{ marginBottom: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
          {/* Substitua os filtros locais pelo FiltroGlobal */}
          <FiltroGlobal />

          <div style={{ flex: 1, maxWidth: "300px" }}>
            <Select
              options={availableDates.map((date) => ({
                label: moment(date).format("DD/MM/YYYY"),
                value: date,
              }))}
              onChange={handleDateChange}
              value={
                selectedDate
                  ? {
                    label: moment(selectedDate).format("DD/MM/YYYY"),
                    value: selectedDate,
                  }
                  : null
              }
              placeholder="Filtrar por Data"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
          <button
            onClick={handleSettingsClick}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="ui button primary"
          >
            ⚙️ Configurações
          </button>
          <button
            onClick={limparFiltros}
            style={{ padding: "10px 20px", cursor: "pointer" }}
            className="ui button secondary"
          >
            🗑️ Limpar Filtros
          </button>
          <button
            onClick={handleDownloadCsv}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon arrow alternate circle down outline"></i>
            Download CSV
          </button>
          <button
            onClick={exportTableToExcel}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            className="ui button secondary"
          >
            <i className="ui icon file excel outline"></i>
            Download Excel
          </button>
        </div>
        <div ref={tableRef}></div>
      </div>
      {sidebarVisible && (
        <div className="sidebar-config">
          <h4 className="ui grey inverted header">
            <i className="ui cog icon"></i> Configurações da Tabela
          </h4>
          <div className="config-content" ref={configTableRef}></div>
          <button className="ui primary button" onClick={applyConfigChanges}>
            <i className="ui save icon"></i> Aplicar
          </button>
        </div>
      )}
      {selectedAtivo && (
        <div style={{
          position: 'fixed',
          right: '20px',
          top: '120px',
          width: '50%',
          height: 'calc(100vh - 140px)',
          maxHeight: '650px',
          backgroundColor: 'white',
          zIndex: 1000,
          boxShadow: '0 0 20px rgba(0,0,0,0.2)',
          borderRadius: '8px',
          padding: '15px',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
            paddingBottom: '10px',
            borderBottom: '1px solid #eee'
          }}>
            <h3 style={{ margin: 0, fontSize: '18px', color: '#333' }}>
              Detalhes da movimentação:
            </h3>
            <button
              onClick={() => setSelectedAtivo(null)}
              style={{
                background: 'none',
                border: 'none',
                color: '#666',
                fontSize: '20px',
                cursor: 'pointer',
                padding: '0 5px'
              }}
            >
              ×
            </button>
          </div>
          <div style={{
            flex: 1,
            minHeight: '300px',
            border: '1px solid #ddd',
            borderRadius: '6px',
            marginBottom: '15px',
            position: 'relative'
          }}>
            <MapContainer
              center={[selectedAtivo.Latitude || -14.235004, selectedAtivo.Longitude || -51.92528]}
              zoom={15}
              style={{
                height: '100%',
                width: '100%',
                borderRadius: '5px',
                minHeight: '300px'
              }}
              whenReady={() => {
                setMapReady(true);
                setTimeout(() => {
                  if (mapRef.current) {
                    mapRef.current.invalidateSize();
                    if (selectedAtivo.Latitude && selectedAtivo.Longitude) {
                      if (marker && mapRef.current.hasLayer(marker)) {
                        mapRef.current.removeLayer(marker);
                      }
                      const newMarker = L.marker(
                        [selectedAtivo.Latitude, selectedAtivo.Longitude],
                        { icon: getMarkerIcon(selectedAtivo.IdAtivo) }
                      ).addTo(mapRef.current);

                      newMarker.bindPopup(`
            <div style="min-width: 200px">
              <strong>Ativo:</strong> ${selectedAtivo.Ativo}<br>
              <strong>Local:</strong> ${selectedAtivo.Local || '-'}<br>
              <strong>Coordenadas:</strong> ${selectedAtivo.Latitude}, ${selectedAtivo.Longitude}<br>
              <strong>Hora inicial:</strong> ${selectedAtivo.timestampIni || '-'}<br>
              <strong>Hora final:</strong> ${selectedAtivo.timestampEnd || '-'}
            </div>
          `);
                      setMarker(newMarker);
                      mapRef.current.flyTo(
                        [selectedAtivo.Latitude, selectedAtivo.Longitude],
                        15,
                        { duration: 1 }
                      );
                    }
                  }
                }, 50);
              }}
              ref={(map) => {
                mapRef.current = map;
              }}
              key={`map-${selectedAtivo.Ativo}`}
              preferCanvas={true}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              {mapReady && (
                <LayersControl position="topright">
                  <LayersControl.BaseLayer checked name="OpenStreetMap">
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                  </LayersControl.BaseLayer>
                  <LayersControl.BaseLayer name="Satellite">
                    <TileLayer
                      url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                      attribution="Tiles &copy; Esri"
                    />
                  </LayersControl.BaseLayer>
                </LayersControl>
              )}
            </MapContainer>
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '15px',
            padding: '10px',
            backgroundColor: '#f8f8f8',
            borderRadius: '6px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', marginTop: '10px' }}>
              <button
                onClick={toggleAnimation}
                className={`ui button ${animationState.isPlaying ? 'red' : 'green'}`}
                disabled={!selectedAtivo?.movementHistory?.length}
              >
                <i className={`icon ${animationState.isPlaying ? 'pause' : 'play'}`}></i>
                {animationState.isPlaying ? 'Pausar' : 'Play'}
              </button>

              <button
                onClick={resetAnimation}
                className="ui button orange"
                disabled={!selectedAtivo || animationState.currentIndex === 0}
              >
                <i className="icon redo"></i>
                Reiniciar
              </button>

              <div className="ui labeled input" style={{ display: 'flex', alignItems: 'center' }}>
                <label className="ui label" style={{ marginRight: '10px' }}>Velocidade:</label>
                <input
                  type="range"
                  min="1"
                  max="10"
                  value={animationState.speed}
                  onChange={(e) => changeSpeed(parseFloat(e.target.value))}
                  style={{ marginRight: '10px' }}
                />
                <span>{animationState.speed.toFixed(1)}x</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MovimentacaoTable;